import { FC } from 'react'
import { useStytchB2BClient, useStytchMemberSession, StytchB2BProvider, StytchB2B } from '@stytch/react/b2b'
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b'
import { IAuthAdapter, WrapperProps } from '..'
import {
  buildStytchStrings,
  discoveryConfig,
  discoveryStyles,
  SESSION_DURATION_MINUTES,
  stytchOptions
} from './StytchAdapter.constants'
import { BRAND } from '@/shared/brand/brand.config'
import { setPermissionsStytchUseCase } from '../../../refactory/modules/access-control/application/set-permissions-stytch.use-case'
import { authRepository } from '../../../refactory/modules/access-control/infrastructure/auth.repository'
import Session from '../../../Main/Services/User/session'
import { useTranslation } from 'react-i18next'
import { WrapperLogin } from './StytchAdapter.styles'
import { KEY_LOCAL_STORAGE_TOKEN } from '../../Auth.constants'

const StytchLoginComponent: FC = () => {
  const { t } = useTranslation()

  const callbacks = {
    onEvent: ({ type }) => {
      if (type === 'AUTHENTICATE_FLOW_COMPLETE' || type === 'B2B_SSO_AUTHENTICATE') {
        window.location.href = '/'
      }
    },
    onError: (_error) => {}
  }

  return (
    <WrapperLogin>
      <StytchB2B
        config={discoveryConfig}
        styles={discoveryStyles}
        callbacks={callbacks}
        strings={buildStytchStrings(t('stytch-sdk', { returnObjects: true }), BRAND)}
      />
    </WrapperLogin>
  )
}

export function useStytchAdapter(): IAuthAdapter {
  const { session } = useStytchMemberSession()
  const stytch = useStytchB2BClient()

  const init = async () => {}

  const redirectLogin = async () => {}

  const getRenderLogin = () => {
    return <StytchLoginComponent />
  }

  const isAuthenticated = async () => {
    return !!session
  }

  const generateToken = async () => {
    const { session_jwt, session_token } = await stytch.session.getTokens()
    Session.set(KEY_LOCAL_STORAGE_TOKEN, session_jwt)

    try {
      await setPermissionsStytchUseCase(authRepository)()
      await stytch.session.updateSession({
        session_token,
        session_jwt
      })
      await stytch.session.authenticate({ session_duration_minutes: SESSION_DURATION_MINUTES })

      const updatedTokens = await stytch.session.getTokens()
      Session.set(KEY_LOCAL_STORAGE_TOKEN, updatedTokens.session_jwt)
      return updatedTokens.session_jwt
    } catch (error) {
      throw error instanceof Error ? error : new Error(String(error))
    }
  }

  const logout = async () => {
    try {
      await stytch.session.revoke()
    } catch (_) {}
  }

  return {
    init,
    getRenderLogin,
    redirectLogin,
    isAuthenticated,
    generateToken,
    logout
  }
}

export const GetWrapperStytch: FC<WrapperProps> = ({ children }) => {
  return (
    <StytchB2BProvider stytch={new StytchB2BUIClient(import.meta.env.VITE_STYTCH_PUBLIC_TOKEN, stytchOptions)}>
      {children}
    </StytchB2BProvider>
  )
}
